import script from "./camera.vue?vue&type=script&setup=true&lang=ts"
export * from "./camera.vue?vue&type=script&setup=true&lang=ts"

import "./camera.vue?vue&type=style&index=0&id=09806420&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09806420"]])

export default __exports__